import { fetch } from '@umu/umu-fetch';
import API from '../../path';

export enum pointStatus {
    open = 1,
    close = 0,
}

export enum IsCollectionAdd {
    true = 1,
    false = 0,
}

export enum IHideSessionNav {
    true = 1,
    false = 0,
}

export enum IsTeacher {
    true = 1,
    false = 0,
}

export enum IsAllowReward {
    true = 1,
    false = 0,
}

export interface ISibLingUrls {
    prev?: string; // 没有时不给这个字段
    next?: string; // 没有时不给这个字段
    pre_session_id?: string;
    next_session_id?: string;
    course_url: string; // 没有时不给这个字段
    next_type?: string;
    prev_type?: string;
    prev_trial_status?: 0 | 1;
    next_trial_status?: 0 | 1;
    next_lock?: 0 | 1;
}
interface ISiblingsEnrollInfo {
    shareUrl: string;
    status: string;
    totalAmount: string;
    setupInfo: {
        begin_time: number;
        end_time: number;
        payment: {
            amount: string;
            switch_status: string;
        };
        remain_user_quota: number;
    };
}
interface ISiblingsUserEnrollInfo {
    enroll_status: number;
    enroll_switch: number;
    enroll_url: string;
    trial_status: number;
}
export interface ISiblingsNavData {
    is_collected: IsCollectionAdd;
    is_open: pointStatus;
    course_trial_status: number;
    enroll?: ISiblingsEnrollInfo;
    is_teacher: IsTeacher;
    points: IUserPoints;
    setup: IGroupSetup;
    siblings: ISibLingUrls;
    user_enroll?: ISiblingsUserEnrollInfo;
}

export const getSiblingsNav = (groupId: number, elementId: number): Promise<ISiblingsNavData> => {
    return fetch
        .get(API.GET_SIBLINGS_NAV.url, {
            group_id: groupId,
            element_id: elementId,
        })
        .then((response: { data: ISiblingsNavData }) => {
            return response.data;
        });
};

export const getSiblingUrls = (elementId: number): Promise<ISibLingUrls> => {
    return fetch
        .get(API.GET_NEXT_URL.url, {
            element_id: elementId,
        })
        .then((response: { data: ISibLingUrls }) => {
            return response.data;
        });
};
